export default __webpack_public_path__ + "static/media/P316 zu P102.d1ae61c7.mp3";